<div class="point-summary-root">
  <div class="score-area">
    <mat-icon class="icon">stars</mat-icon>
    <div class="infos-score">
      <div class="score-label">{{labels.totalPoints}}</div>
      <div class="score">
        {{ pointSummary?.totalPoints | number:'': language }}
      </div>
    </div>
  </div>
  <div class="content">
    <div class="infos">
      <span class="subscript">{{labels.pointsAddedMonth}}</span>
      <div class="score-detail">
        {{ pointSummary?.addedOnThisMonth | number:'': language }}
      </div>
    </div>
    <div class="infos">
      <span class="subscript">{{labels.pointsRedeemedMonth}}</span>
      <div class="score-detail">
        {{ pointSummary?.redeemedOnThisMonth | number:'': language }}
      </div>
    </div>
    <div class="infos">
      <span class="subscript">{{labels.pointsExpiringMonth}}</span>
      <div class="score-detail">
        {{ pointSummary?.expiringOnThisMonth | number:'': language }}
      </div>
    </div>
    <div class="infos">
      <span class="subscript">{{labels.nextPointsExpiring}}</span>
      <div class="score-detail">
        {{ pointSummary?.nextPointsExpiring | number:'': language }} ({{ getPointExpiringDate() }})
      </div>
    </div>
    <div class="infos">
      <span class="subscript">{{labels.pointsExpired}}{{getThisYear()-1}}</span>
      <div class="score-detail">
        {{ pointSummary?.expiredLastYear | number:'': language}}
      </div>
    </div>
    <div class="infos">
      <span class="subscript">{{labels.pointsExpiring}}{{getThisYear()}}</span>
      <div class="score-detail">
        {{ pointSummary?.expiringOnThisYear | number:'': language}}
      </div>
    </div>
    <div class="infos">
      <span class="subscript">{{labels.pointsExpiring}}{{getThisYear()+1}}</span>
      <div class="score-detail">
        {{ pointSummary?.expiringOnNextYear | number:'': language}}
      </div>
    </div>
  </div>
  <div class="button-content">
    <app-secondary-button transparent
                          (clickAction)="openCreateReportModal()"
                          id="lnr-generate-report-button"
                          icon="assignment"
    >{{labels.generateReport}}</app-secondary-button>
  </div>
</div>
